import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { useCart } from "../../cart/CartContext";
import "./Header.css";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [framesMenuOpen, setFramesMenuOpen] = useState(false);
  const { totals } = useCart();

  const closeNavigation = () => {
    setMobileMenuOpen(false);
    setFramesMenuOpen(false);
  };

  return (
    <header className="site-header">
      <Link to="/" className="site-logo-link" onClick={closeNavigation}>
        <img
          src="/images/branding/logo_imalandia.png"
          alt="Imalandia"
          className="site-logo"
        />
      </Link>

<button
  type="button"
  className="mobile-menu-button"
  onClick={() => {
    setMobileMenuOpen(!mobileMenuOpen);
    setFramesMenuOpen(false);
  }}
  aria-label={mobileMenuOpen ? "Cerrar menú" : "Abrir menú"}
  aria-expanded={mobileMenuOpen}
>
  ☰
</button>

      <nav className={`site-nav ${mobileMenuOpen ? "site-nav-open" : ""}`}>
        <NavLink to="/" onClick={closeNavigation}>
          Inicio
        </NavLink>

        <NavLink
  to="/imanes-personalizados-con-fotos"
  onClick={closeNavigation}
  className="site-nav-cta"
>
  Crear imanes
</NavLink>

        <NavLink to="/editor" onClick={closeNavigation}>
          Collage
        </NavLink>

        <div
          className={`site-nav-dropdown ${
            framesMenuOpen ? "site-nav-dropdown-open" : ""
          }`}
          onMouseEnter={() => setFramesMenuOpen(true)}
          onMouseLeave={() => setFramesMenuOpen(false)}
        >
          <button
            type="button"
            className="site-nav-dropdown-trigger"
            onClick={() => setFramesMenuOpen(!framesMenuOpen)}
            aria-expanded={framesMenuOpen}
          >
            Marcos
          </button>

          <div className="site-nav-dropdown-menu">
            <NavLink to="/marcos-individuales" onClick={closeNavigation}>
              Marcos individuales
            </NavLink>

            <NavLink to="/marco-duo" onClick={closeNavigation}>
              Marco Duo
            </NavLink>

            <NavLink to="/marco-mosaico" onClick={closeNavigation}>
              Marco Mosaico
            </NavLink>

            <NavLink to="/marco-secuencia" onClick={closeNavigation}>
              Marco Secuencia
            </NavLink>
          </div>
        </div>

        <NavLink to="/ofertas" onClick={closeNavigation}>
          Ofertas
        </NavLink>

        <Link to="/#tienda" onClick={closeNavigation}>
          Tienda
        </Link>

        <NavLink to="/contacto" onClick={closeNavigation}>
          Contacto
        </NavLink>

        <NavLink
          to="/carrito"
          onClick={closeNavigation}
          className="site-nav-cart"
        >
          Carrito
          <span>{totals.totalQuantity}</span>
        </NavLink>
      </nav>
    </header>
  );
}
